import Shubox from '@shubox/core'
export default Shubox
